/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Global rating: 1-5 stars, or CSR-I / CSR-NS / NG when not rated
 */
export enum CmsOverallRating {
  _1 = '1',
  _2 = '2',
  _3 = '3',
  _4 = '4',
  _5 = '5',
  CSR_I = 'CSR-I',
  CSR_NS = 'CSR-NS',
  NG = 'NG',
}
